import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, BACKEND_URL } from "@/lib/api";
import { Flame, Eye, Coins } from "lucide-react";

/** "Hot right now" rail — coins getting views/tips today, refreshed every 60s. */
export default function HotRail() {
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = () =>
      api.get("/coins/hot").then((r) => {
        if (alive) setCoins(r.data.coins || []);
      }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  if (coins.length === 0) return null;

  return (
    <div className="mb-8" data-testid="hot-rail">
      <div className="flex items-center gap-2 mb-3">
        <Flame size={14} className="text-[#ff6b35]" />
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#ff6b35]">
          Hot right now
        </span>
        <span className="w-1.5 h-1.5 bg-[#ff6b35] live-dot" />
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1">
        {coins.map((c, i) => (
          <Link
            key={c.slug}
            to={`/c/${c.slug}`}
            data-testid={`hot-coin-${c.slug}`}
            className="group flex-shrink-0 w-56 border border-[#2a1a12] bg-gradient-to-b from-[#140c08] to-[#0a0a0a] hover:border-[#ff6b35] transition-colors p-4"
          >
            <div className="flex items-center gap-3 mb-3">
              <span className="font-display font-black text-lg text-[#ff6b35]/60">#{i + 1}</span>
              <div className="w-9 h-9 flex-shrink-0 border border-[#3a3a3a] bg-[#050505] overflow-hidden">
                <img
                  src={`${BACKEND_URL}/api/coins/${c.slug}/logo`}
                  alt={c.name}
                  className="w-full h-full object-cover"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
              </div>
              <div className="min-w-0">
                <div className="font-display text-sm font-bold uppercase truncate">{c.name}</div>
                <div className="font-mono text-[11px] text-[#d0d0d0]">${c.ticker}</div>
              </div>
            </div>
            <div className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-wider text-[#e2e2e2]">
              <span className="flex items-center gap-1">
                <Eye size={10} className="text-[#ff6b35]" /> {c.views_today} today
              </span>
              {c.tips_24h > 0 && (
                <span className="flex items-center gap-1">
                  <Coins size={10} className="text-[#cfff04]" /> {c.tips_24h} tips
                </span>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
